interface SystemInfo {
    appName?: string|undefined,
    appVersion?: string|undefined,
    device?: string|undefined,
    osVersion?: string|undefined,
};

export const systemInfo:SystemInfo = {
    appName: undefined,
    appVersion: undefined,
    device: undefined,
    osVersion: undefined,
};